import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {DatesAssetsDetailModel, datesAssetsDetailModelFactory} from "./dates-assets-detail.model";

const DEFAULT_PAGE = 0;
const DEFAULT_PAGE_LIMIT = 10;

@Injectable()
export class OrderWorkflowService {
  private url: string = "/api/orderworkflow";

  constructor(private http: HttpClient) {}

  getLeaseAssets(orderId: string, limit: number, page: number):
    Promise<{rows: any[], count: number, assetsWithNoSnMacAddress: number}> {
    const params: {[key: string]: string} = {
      page: `${page !== undefined ? page : DEFAULT_PAGE}`,
      limit: `${limit !== undefined ? limit : DEFAULT_PAGE_LIMIT}`,
      orderId,
      sequence: "true",
    };

    return this.http.get<{rows: any[], count: number, assetsWithNoSnMacAddress: number}>(`${this.url}/list-lease-assets`, {params})
      .pipe(map(({rows, count, assetsWithNoSnMacAddress}) => ({rows, count: +count, assetsWithNoSnMacAddress})))
      .toPromise();
  }

  updateDetails(orderId: string, assets: any[]): Promise<{result: any}> {
    return this.http.post<{result: any}>(`${this.url}/update-asset-details/${orderId}`, {assets})
      .pipe(map(({result}) => ({result})))
      .toPromise();
  }

  notifyOrderAcceptance(orderId: string): Promise<any> {
    return this.http.post<any>(`${this.url}/notify-order-acceptance`, {orderId})
      .toPromise();
  }

  getOrderCanBeRejected(orderId: string, workflowId: string): Promise<boolean> {
    const params: {[key: string]: string} = {};

    if (orderId) params.orderId = orderId;
    if (workflowId) params.workflowId = workflowId;

    return this.http.get<{canBeRejected: boolean}>(`${this.url}/can-order-rejected`, {params})
      .pipe(map(json => !!json.canBeRejected))
      .toPromise();
  }

  getDatesAssetsDetails(orderId: string): Promise<DatesAssetsDetailModel> {
    const params: {[key: string]: string} = {orderId};

    return this.http.get<{result: any}>(`${this.url}/dates-assets-details`, {params})
      .pipe(map(datesAssetsDetailModelFactory))
      .toPromise();
  }

  updateDatesAssetsDetails(orderId: string, dates: DatesAssetsDetailModel): Promise<{result: any}> {
    return this.http.post<{result: any}>(`${this.url}/update-dates-assets-details/${orderId}`, {dates})
      .pipe(map(({result}) => ({result})))
      .toPromise();
  }
}
